import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import type { ITicketStageHistory } from './TicketStageHistory.interface';

export default class TicketStageHistory implements ITicketStageHistory {
  id: string;
  idOwner: string;
  idStage: string;
  timeStamp: number;

  static build = (data: ITicketStageHistory) => new TicketStageHistory(data);
  static blank = () => new TicketStageHistory({ id: uuid(), timeStamp: epoch(utc()) });

  /**
   * Constructor
   * @param {ITicketStageHistory} data
   */
  constructor(data?: ITicketStageHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idOwner = toUUID(data?.idOwner);
    this.idStage = toUUID(data?.idStage);
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
